<div class="incident-number">
	<a
		[ngClass]="incidentItem.status === 'CREATED' ? 'active-link' : 'disabled'"
		(click)="viewSelectedEntity()"
		>Incident #{{ incidentItem.ID }}
	</a>

	@if (incidentItem.status === 'DISCARDED') {
		<button mat-stroked-button (click)="setIncidentStatus('NOSTATUS')">
			<mat-icon svgIcon="undo"></mat-icon>
			Undo Discard
		</button>
	}
	@if (incidentItem.status === 'CREATED') {
		<button
			mat-stroked-button
			class="delete-button"
			(click)="setIncidentStatus('DELETED')"
		>
			<mat-icon svgIcon="delete"></mat-icon>
			Remove Incident
		</button>
	}
	@if (!incidentItem.status || incidentItem.status === 'DELETED') {
		<div class="button-group">
			<button
				[matTooltip]="'Discard Incident'"
				mat-button
				(click)="setIncidentStatus('DISCARDED')"
			>
				DISCARD
			</button>
			<button mat-flat-button (click)="setIncidentStatus('CREATED')">
				CREATE INCIDENT
			</button>
		</div>
	}
</div>
<div class="form">
	<au-cmms-entity-name
		[name]="incidentItem.name"
		(inputBlur)="changeData('name', $event)"
	></au-cmms-entity-name>
</div>
<div class="form">
	<cmms-description
		[textModeEnabled]="true"
		[description]="incidentItem.description"
		(descriptionBlur)="changeData('description', $event)"
	></cmms-description>
</div>

<div class="form priority-and-category">
	<cmms-priority-level
		class="priority"
		[priorityLevel]="incidentItem.priority"
		(priorityLevelChanged)="changeData('priority', $event)"
	></cmms-priority-level>

	<cmms-entity-category
		class="category"
		[selectedCategory]="incidentItem.category"
		(categoryChanged)="changeData('category', $event)"
	></cmms-entity-category>
</div>

<div class="form assignee-section m-b-xs">
	<cmms-assignee-and-approver
		[assignee]="incidentItem.assignee"
		[approver]="incidentItem.approvedBy"
		(assigneeUpdate)="changeAssigneeData('assignee', $event)"
		(approverUpdate)="changeAssigneeData('approvedBy', $event)"
	/>
</div>
